import { useRequest } from 'ahooks';
import request from 'lib/request';
export interface Response {
  code: number;
  data: TwitterUserInfo;
  msg: string;
}

/**
 * twitter_user_info
 */
export interface TwitterUserInfo {
  /**
   * 名字，如：name
   */
  name: string;
  /**
   * screen_name，如：ZenQingan
   */
  twitter_username: string;
  /**
   * 用户id，如：1526198706562686976
   */
  twitter_user_id: string;
  id?: string;
  logo: string;
}

export async function getSocialTwitterInfoGlobally(screen_name: string) {
  const res = await request<Response>('/v1/social/twitter_info', {
    prefix: process.env.NEXT_PUBLIC_LUCKYBX_CLIENT_API,
    params: {
      screen_name,
    },
  });
  return res?.data;
}

export async function getSocialTwitterInfo(screen_name: string) {
  const res = await request<Response>('/v1/social/twitter_info', {
    prefix: process.env.NEXT_PUBLIC_LUCKYBX_CLIENT_API,
    params: {
      screen_name,
    },
  });
  return res?.data;
}
